module.exports = __webpack_public_path__ + "static/01-f2552adfe4ae2db982c47f5dd178e3e8.jpg";